/**
 * GSB Core Configuration
 */

export * from './gsb-config';
